import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { tapumeAtivo } from './config/tapume';
import Tapume from './pages/site/Tapume';

// ── Site comercial (público) ──
import CommercialHome from './pages/site/CommercialHome';
import QuemSomos from './pages/site/QuemSomos';
import Objetivo from './pages/site/Objetivo';
import SitePlanos from './pages/site/Planos';

// ── Plataforma de treinamentos (/treinamentos) ──
import Cadastro from './pages/Home';
import Login from './pages/Login';
import Cursos from './pages/Cursos';
import CoursePlayer from './pages/CoursePlayer';
import UserProfile from './pages/UserProfile';
import MeusCursos from './pages/MeusCursos';
import PlanoEstudos from './pages/PlanoEstudos';
import Planos from './pages/Planos';

// ── Painel administrativo (/treinamentos/manager) ──
import AdminLogin from './admin/pages/Login';
import AdminDashboard from './admin/pages/Dashboard';
import AdminCourses from './admin/pages/Courses';
import AdminCourseForm from './admin/pages/CourseForm';
import AdminCourseVideos from './admin/pages/CourseVideos';
import AdminPlans from './admin/pages/Plans';
import AdminPlanForm from './admin/pages/PlanForm';
import AdminGoals from './admin/pages/Goals';
import AdminProfile from './admin/pages/Profile';
import AdminReset from './admin/pages/ResetAdmin';

function App() {
  if (tapumeAtivo()) return <Tapume />;
  return (
    <BrowserRouter>
      <Routes>
        {/* ── Site comercial (público) ── */}
        <Route path="/" element={<CommercialHome />} />
        <Route path="/quem-somos" element={<QuemSomos />} />
        <Route path="/objetivo" element={<Objetivo />} />
        <Route path="/planos" element={<SitePlanos />} />

        {/* ── Plataforma de treinamentos ── */}
        <Route path="/treinamentos" element={<Login />} />
        <Route path="/treinamentos/cadastro" element={<Cadastro />} />
        <Route path="/treinamentos/cursos" element={<Cursos />} />
        <Route path="/treinamentos/planos" element={<Planos />} />
        <Route path="/treinamentos/curso/:courseId" element={<CoursePlayer />} />
        <Route path="/treinamentos/meus-cursos" element={<MeusCursos />} />
        <Route path="/treinamentos/plano-estudos" element={<PlanoEstudos />} />
        <Route path="/treinamentos/perfil" element={<UserProfile />} />

        {/* ── Painel administrativo ── */}
        <Route path="/treinamentos/manager" element={<AdminLogin />} />
        <Route path="/treinamentos/manager/dashboard" element={<AdminDashboard />} />
        <Route path="/treinamentos/manager/courses" element={<AdminCourses />} />
        <Route path="/treinamentos/manager/courses/new" element={<AdminCourseForm />} />
        <Route path="/treinamentos/manager/courses/:courseId/edit" element={<AdminCourseForm />} />
        <Route path="/treinamentos/manager/courses/:courseId/videos" element={<AdminCourseVideos />} />
        <Route path="/treinamentos/manager/plans" element={<AdminPlans />} />
        <Route path="/treinamentos/manager/plans/new" element={<AdminPlanForm />} />
        <Route path="/treinamentos/manager/plans/:planId/edit" element={<AdminPlanForm />} />
        <Route path="/treinamentos/manager/goals" element={<AdminGoals />} />
        <Route path="/treinamentos/manager/profile" element={<AdminProfile />} />
        <Route path="/treinamentos/manager/reset-admin" element={<AdminReset />} />

        {/* Rota desconhecida → site comercial */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
